var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { FooterStyled, ListItemsStyled, SwiperStyled } from "./style";
import paymentMethods from "./paymentMethods";
import { SwiperSlide } from "swiper/react"; //https://swiperjs.com/react/
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper";
var config = {
    spaceBetween: 1,
    pagination: true,
    modules: [Pagination, Autoplay],
    slidesPerView: 4,
    slidesPerGroup: 2,
    loop: true,
    autoplay: {
        delay: 3500,
        disableOnInteraction: false,
    },
};
var Footer = function () {
    return (React.createElement(FooterStyled, null,
        React.createElement("p", { className: "footerTitle" }, "Medios de pago disponibles"),
        React.createElement(ListItemsStyled, null, paymentMethods.map(function (method) { return (React.createElement("li", { key: method.name },
            React.createElement("img", { src: method.image, alt: method.name }))); })),
        React.createElement(SwiperStyled, __assign({}, config), paymentMethods.map(function (method) { return (React.createElement(SwiperSlide, { key: method.name },
            React.createElement("div", null,
                React.createElement("img", { src: method.image, alt: method.name })))); }))));
};
export default Footer;
